import { QRCodeSVG } from 'qrcode.react';
import logoIcon from 'design-system/src/assets/lean-agility-logo.svg';

import { useSimulationContext } from '../../SimulationContext';
import { Page } from '../organisms';

export function OperatorQRPage() {
  const { label } = useSimulationContext();
  const joinUrl = `${window.location.origin}/join/${encodeURIComponent(label)}`;

  return (
    <Page title={null}>
      <div className="flex flex-col items-center gap-6 mt-8">
        <div className="bg-white p-6 rounded-xl">
          <QRCodeSVG
            value={joinUrl}
            size={320}
            level="H"
            imageSettings={{
              src: logoIcon,
              height: 80,
              width: 120,
              excavate: true,
            }}
          />
        </div>
        <p className="text-lg font-mono font-bold">{label}</p>
        <p className="text-sm text-text-secondary break-all max-w-md text-center">{joinUrl}</p>
      </div>
    </Page>
  );
}
